export default __webpack_public_path__ + "media/zurb/img/legacy/spur/grayscale-dcdf83611b933bcd2cad10a5d85538be.jpg";